import { useCurrentStream } from '../../feature-player/hooks/player-instance/use-current-stream';

import { useReadSportPlayerBaseInfo } from './useReadSportPlayerBaseInfo';

export const useCurrentSportStream = (contentId: string) => {
    const baseInfo = useReadSportPlayerBaseInfo(contentId);

    return useCurrentStream(baseInfo?.onlineStreams?.streams);
};
